import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';

class Toast extends React.Component {
  constructor(props) {
    const { dismiss } = props;
    super(props);
    this.timerId = 0;
    this.state = {
      visible: true,
      start: 0,
      time: dismiss
    };
  }

  componentDidMount() {
    const { isDismissable } = this.props;
    if (isDismissable) this.startTimer();
  }

  componentWillUnmount() {
    const { isDismissable } = this.props;
    if (isDismissable) clearInterval(this.timerId);
  }


  getIconBasedOnColor(color) {
    const icon = icons[color];
    return icon ? <FontAwesomeIcon icon={icon} size="sm" /> : null;
  }

  handleMouseLeave = () => {
    const { isDismissable } = this.props;
    if (isDismissable) this.startTimer();
  };

  onDismiss = () => {
    const { onClose, id } = this.props;
    this.setState({ visible: false });
    if (onClose) { onClose(id); }
  };

  handleMouseEnter = () => {
    const { isDismissable } = this.props;
    if (isDismissable) this.pauseTimer();
  };

  startTimer = () => {
    const { time } = this.state;
    const { onClose, id } = this.props;
    this.setState({
      start: Date.now()
    });
    this.timerId = setInterval(() => {
      this.setState({
        visible: false
      });
      if (onClose) { onClose(id); }
    }, time);
  };

  pauseTimer = () => {
    const { start, time } = this.state;
    const remaining = Date.now() - start;
    this.setState({
      time: time - remaining
    });
    clearInterval(this.timerId);
  };

  render() {
    const { visible } = this.state;
    const { color, text, t, translation, textDefault, iconQuestion } = this.props;
    const toastClasses = classNames({
      'toast-msg': true,
      'alert-dismissible': true,
      [`alert-${color}`]: true,
      'toast-msg-default': textDefault
    });

    return (
      <Fragment>
        {
          visible
            ? (
              <div className={toastClasses} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                {iconQuestion && <FontAwesomeIcon  className="ml-1" icon={faQuestionCircle} size="lg" />}
                <div className="toast-icon">
                  <span aria-hidden="true">
                    {this.getIconBasedOnColor(color)}
                  </span>
                </div>
                <div className="toast-content">
                  {translation ? t(text) : text}
                </div>
                <div className="toast-action">
                  <button type="button" className="close" aria-label="Close" onClick={this.onDismiss}>
                    <span aria-hidden="true">
                      <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'times' }} size="xs" />
                    </span>
                  </button>
                </div>
              </div>
            )
            : ''
        }
      </Fragment>
    );
  }
}

const icons = {
  success: { prefix: 'fa', iconName: 'check-circle' },
  danger: { prefix: 'fa', iconName: 'exclamation-circle' },
  warning: { prefix: 'fa', iconName: 'exclamation-triangle' },
  primary: { prefix: 'fa', iconName: 'info-circle' }
};

Toast.propTypes = {
  color: PropTypes.string,
  dismiss: PropTypes.number,
  text: PropTypes.string.isRequired,
  isDismissable: PropTypes.bool,
  translation: PropTypes.bool,
  onClose: PropTypes.func
};

Toast.defaultProps = {
  color: 'primary',
  dismiss: 5000,
  isDismissable: true,
  translation: true,
  textDefault: false
};

export default withNamespaces()(Toast);
